<template>
    <div id="mallHome">
        <nav-bar class="nav-bar"><div slot="center">购物街</div></nav-bar>
        <tab-control class="fixed" :titles="['流行','精选','新款']" @tabClick="tabClick"
                     ref="topTabControl" v-show="isTabFixed"></tab-control>
        <Scroll class="wrapper" ref="scroll"
                :probe-type="3"
                @scroll="contentScroll"
                :pull-up-load="true"
                @pullingUp="loadMore">
            <home-swiper :banners="banners"
                         ref="hswiper" @swiperImageLoad="swiperImageLoad"></home-swiper>
            <RecommendView :recommends="recommends"></RecommendView>
            <FeatureView></FeatureView>
            <tab-control  :titles="['流行','精选','新款']" @tabClick="tabClick"
                          ref="tabControl"></tab-control>
            <goods-list :goods="showGoods"></goods-list>

        </Scroll>
        <BackTop @click.native="backCli" v-show="isShowBackTop"></BackTop>

    </div>
</template>

<script>
    import NavBar from "../../components/common/navbar/NavBar";
    import Scroll from "../../components/common/scroll/Scroll";
    import HomeSwiper from "./childComps/HomeSwiper";

    import RecommendView from "./childComps/RecommendView";

    import BackTop from "../../components/content/backTop/BackTop";
    import FeatureView from "./childComps/FeatureView";
    import tabControl from "../../components/content/tabControl/tabControl";
    import GoodsList from "../../components/content/goods/GoodsList";


    import {getHomeMultidata,getHomeGoods} from '../../components/network/home';
    import {goodsitemImageLoadRefresh,tabControlMixin} from "../../components/common/mixin";


    export default {
        name: "MallHome",
        components:{
            NavBar,
            Scroll,
            HomeSwiper,
            RecommendView,
            FeatureView,
            tabControl,
            GoodsList,
            BackTop,
        },
        mixins:[goodsitemImageLoadRefresh,tabControlMixin],
        data(){
            return{
                banners:[],
                recommends:[],
                goods:{
                    'pop': {page: 1, list: []},
                    'new': {page: 1, list: []},
                    'sell': {page: 1, list: []}
                },
                currentType:'pop',
                isShowBackTop:true,
                tabOffsetTop: 0,
                isTabFixed: false,
                saveY:0,
            }
        },
        created() {
            this.getHomeMultidata();
            this.getHomeGoods('pop');
            this.getHomeGoods('new');
            this.getHomeGoods('sell');


        },
        mounted() {
            // alert(this.currentType)
            // console.log(this.goods)
        },
        computed:{
            showGoods(){
                return this.goods[this.currentType].list;
            },

        },
        activated(){
            // setTimeout(()=>{
            //     this.$refs.scroll.scrollTo(0,this.saveY,0);
            // },1000)
            this.$refs.scroll.scroll.refresh();
            this.$refs.scroll.scrollTo(0,this.saveY,0);
            // this.$refs.scroll.scroll.refresh();

        },
        deactivated(){
            this.saveY=this.$refs.scroll.getScrollY();
            // 取消对全局事件对该组件this.GoodsListItemImgListener的监听
            this.$bus.$off(this.GoodsListItemImgListener);

            // console.log(this.saveY)
        },
        methods:{
            swiperImageLoad(){
                this.TabControlPosition()
                // this.tabOffsetTop=this.$refs.tabControl.$el.offsetTop;
                // console.log(this.$refs.tabControl.$el.offsetTop);
            },
            //事件监听方法
            // tabClick(index){
            //     switch (index) {
            //         case 0:
            //             this.currentType='pop';
            //             break;
            //         case  1:
            //             this.currentType='new';
            //             break;
            //         case 2:
            //             this.currentType='sell';
            //             break
            //     }
            //     this.$refs.tabControl.currentIndex=index;
            //     this.$refs.topTabControl.currentIndex=index;
            //
            // },
            backCli(){
                this.$refs.scroll.scrollTo(0,0,500);
            },
            contentScroll(position){
                this.isShowBackTop= (-position.y) >1000;
                // this.showTabControl()
                this.isTabFixed=position.y<(-this.tabOffsetTop);
            },
            loadMore(){
                // console.log('上拉加载更多')
                this.getHomeGoods(this.currentType)
            },

            //网络请求方法
            getHomeMultidata(){
                getHomeMultidata().then(res=>{
                    this.banners=res.data.banner.list;
                    this.recommends=res.data.recommend.list;

                })
            },
            getHomeGoods(type){
                // let itype=type;
                // console.log(type)
                const page =this.goods[type].page;
                getHomeGoods(type,page).then(res=>{
                    // console.currentTyperes)
                    this.goods[type].list.push(...res.data.list);
                    this.goods[type].page +=1;
                    this.$refs.scroll.finishPullUp();

                })
            }
        }
    }
</script>

<style scoped>
    #mallHome{
        height: 100vh;

    }
    .nav-bar{
        background-color: var(--color-tint);
        font-weight:700;
        color:#fff;
    }
    .tab-control{
        position: sticky;
        /*top: 0px;*/
    }
    .wrapper{
        position: relative;
        height: calc(100% - 93px);
        /*height: 580px;*/
        background-color: red;
        overflow: hidden;
        /*overflow: hidden;*/
    }
    .tab-control{
        position: relative;
        z-index: 9;
    }
    .fixed {
        position: fixed;
        top: 104px;
        left: 0;
        right: 0;
    }
</style>